<template>
  <div class="hideTotal">
    <table-search
      @search="fetchGoodsData()"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <el-form-item label="业务日期">
          <el-date-picker
            v-model="dataRange"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
          />
        </el-form-item>
        <el-form-item label="主体">
          <el-select v-model="query.companyId">
            <el-option
              v-for="(item, index) in companyList"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="exportExcel('LOAN_IN')" />
    <el-table
      :data="tableData"
      border
    >
      <el-table-column
        prop="memberNumber"
        min-width="100"
        label="客户号"
      />
      <el-table-column
        prop=""
        label="日期"
      >
        <template slot-scope="scope">
          <!-- 支付成功、失败状态不显示 -->
          <el-button
            type="text"
            @click="toJump(scope.row.bizDate)"
          >
            {{ scope.row.bizDate }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop="areaName"
        min-width="100"
        label="区域名称"
      />
      <el-table-column
        prop=""
        min-width="100"
        label="期初货款"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #606266;"
          >
            {{ scope.row.lastDayBalance | amount }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        min-width="100"
        label="总计转入（元）"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #606266;"
          >
            {{ scope.row.todayAdd | amount }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        min-width="100"
        label="总计转出（元）"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #606266;"
          >
            {{ scope.row.todayReduce | amount }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        min-width="100"
        label="期末货款（元）"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #606266;"
          >
            {{ scope.row.todayBalance | amount }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        min-width="120"
        label="冻结货款余额（元）"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #606266;"
          >
            {{ scope.row.frozenBalance | amount }}
          </el-button>
        </template>
      </el-table-column>
      <el-table-column
        prop=""
        min-width="100"
        label="可用货款（元）"
      >
        <template slot-scope="scope">
          <el-button
            type="text"
            style="color: #606266;"
          >
            {{ scope.row.canUseBalance | amount }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
    <div style="margin-top: 80px;">
      <el-form
        :inline="true"
        class="demo-form-inline"
        label="汇总"
      >
        <el-form-item label="总计转入（元）:">
          <p class="gather">
            {{ gather.todayAdd | amount }}
          </p>
        </el-form-item>
        <el-form-item label="总计转出（元）:">
          <p class="gather">
            {{ gather.todayReduce | amount }}
          </p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'
import mixin from '@/utils/mixinFile'

function Query () {
  // earlySettlement 提前 20 到期10
  this.bizDate = ''
  this.startDate = ''
  this.companyId = 'hCsAAAAAAYDM567U'
  this.memberNumber = ''
  this.token = ''
  this.year = ''
  this.month = ''
  this.dateStart = ''
  this.dateEnd = ''
}
export default {
  name: 'PaymentForGoods',
  filters: {
    // 金额
    amount (amount) {
      if (amount) {
        var f1 = parseFloat(amount)
        if (isNaN(f1)) {
          return false
        }
        var f2 = Math.round(amount * 100) / 100
        var s = f2.toString()
        var rs = s.indexOf('.')
        if (rs < 0) {
          rs = s.length
          s += '.'
        }
        while (s.length <= rs + 2) {
          s += '0'
        }
        return s
      } else {
        return '0.00'
      }
    }
  },
  mixins: [mixin],
  data () {
    return {
      bizDate: new Date(),
      companyList: [],
      dataRange: [],
      query: new Query(),
      // 列表信息
      gather: {},
      tableData: [],
      currentPage: 1,
      total: 0,
      pageSize: 100
    }
  },
  async created () {
    // this.dataRange = [getFirstDayOfCurrentMonth(), new Date()]
    let myDate = new Date()
    this.year = myDate.getFullYear() + ''
    this.month = myDate.getMonth() + 1
    if (this.month < 10) {
      this.month = '0' + this.month
    }
    this.startDate = this.year + '-' + this.month + '-01'
    this.bizDate = this.year + '-' + this.month + '-' + this.getCurrentMonthLast()

    api.spotPurchaseSaleInquiry.getToken().then((res) => {
      this.query.token = res
      this.query.memberNumber = JSON.parse(localStorage.getItem('pro__USER_INFO')).value.account || '000108'
      this.getAllCompany()
      this.fetchGoodsData(10, 1)
    })
  },
  methods: {
    // 获取列表数据
    fetchGoodsData (size, page) {
      this.currentPage = page
      let param = {
        pageSize: size || 10,
        currentNo: page || 1,
        startDate: this.dataRange.length ? `${dayJs(this.dataRange[0]).format('YYYY-MM-DD')} 00:00:00` : this
          .startDate,
        bizDate: this.dataRange.length ? `${dayJs(this.dataRange[1]).format('YYYY-MM-DD')} 23:59:59` : this.bizDate,
        memberNumber: this.query.memberNumber || '000108',
        companyId: this.query.companyId,
        token: this.query.token || '83c6409e6e43499a9dea742ef831c8f8'
      }
      this.query.bizDate = param.bizDate
      this.query.startDate = param.startDate
      api.spotPurchaseSaleInquiry.paymentList(param).then((res) => {
        this.tableData = res.data.data.rows
        this.total = res.data.data.totalElements
        this.gather = res.data.data.gather || {}
      }).catch((err) => {
        this.$message.error(err)
      })
    },
    // 获取渠道
    async getAllCompany () {
      this.companyList = (await api.spotPurchaseSaleInquiry.getAllCompany(this.query)).data
    },
    // 分页
    changePage (page) {
      this.fetchGoodsData(10, page)
    },
    // 重置
    handleReset () {
      this.query.endDate = ''
      this.query.beginDate = ''
      this.query.companyId = 'hCsAAAAAAYDM567U'
      this.fetchGoodsData(10, 1)
    },

    // 日期跳转
    toJump (date) {
      this.$router.push({
        path: '/spot-purchase-sale-inquiry/payment-account/daily-statement', // 跳到日报表
        query: {
          date: date,
          memberNumber: this.query.memberNumber || '000108',
          token: this.query.token || '83c6409e6e43499a9dea742ef831c8f8'
        }
      })
    },

    // 获取日期
    getCurrentMonthLast () {
      var curDate = new Date()
      var curMonth = curDate.getMonth()
      curDate.setMonth(curMonth + 1)
      curDate.setDate(0)
      return curDate.getDate()
    }
  }
}

</script>

<style lang="scss" scoped>
  .pagination {
    margin: 20px 0 20px 0;
    float: right;
  }

  .gather {
    width: 70px;
    margin-right: 20px;
  }

  .inqueryResult+div {
    margin-top: 15px;
    border: none;
  }

</style>
